import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { storage as LocalStorage } from 'services/config/storage';
import { IRO_API_URL } from '../../services/config/apiUrl';
import { Modal, Button } from "antd"
import "./index.scss"
import { withRouter } from 'react-router-dom';
import { usePreviousPath } from '../../hooks/usePreviousPath';

const IroExamAlertModal = ({ history, location }) => {
    const [visible, setVisible] = useState(false);
    const [examToday, setExamToday] = useState(null)
    const prevPath = usePreviousPath(history,location);

    const getExamList = async () => {
        const child = LocalStorage.fetch.defaultChild();
        const isTeacher = LocalStorage.fetch.parentData()?.is_teacher
        const isLogin = LocalStorage.fetch.authToken()

        if (!child?.id && isTeacher && !isLogin) return;

        try {
            const testListRes = await Axios.get(
                `${IRO_API_URL}irotest/v1/iro-list/?child_id=${child.id}`,
                {
                    headers: {
                        'api-version': '1.1.0',
                        'device-type': 'web',
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (testListRes?.data?.success) {
                const examsList = testListRes.data.result;

                const isExamToday = examsList.find((exam) => {
                    const examDate = new Date(`${exam.exam_date}T00:00:00Z`);
                    const clientNow = new Date();
                    const currentDate = new Date(
                        Date.UTC(clientNow.getUTCFullYear(), clientNow.getUTCMonth(), clientNow.getUTCDate())
                    );

                    return examDate.getTime() === currentDate.getTime();
                });


                if (isLogin && !isTeacher && isExamToday && !window.location.pathname.includes("assessments") && !isExamToday?.already_attempt) {
                    setExamToday(isExamToday)
                    setVisible(true);
                }
            }

            return testListRes;
        } catch (error) {
            console.error('Error fetching exam list:', error);
        }
    };

    useEffect(() => {
        if (prevPath) {
            if (prevPath.includes("/assessments")) getExamList()
        } else {
            getExamList();
        }
    }, [location.pathname]);

    return (
        <Modal
            visible={visible}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <div className="iro_alert_modal_container">
                <p className='iro_alert_modal_heading'>
                    {
                        `Your ${examToday?.name} is scheduled for today. Kindly ensure it is completed before the day ends.`
                    }
                </p>
                <Button type="primary" onClick={() => { setVisible(false); history.push("/assessments") }}>Go to Assessments Page</Button>
            </div>

        </Modal>
    );
};

export default withRouter(IroExamAlertModal);
